const monthMap = {
  january: 0,
  february: 1,
  march: 2,
  april: 3,
  may: 4,
  june: 5,
  july: 6,
  august: 7,
  september: 8,
  october: 9,
  november: 10,
  december: 11,
};

export const parseKeywordToDate = (keyword) => {
  const lower = keyword.toLowerCase();

  // Match full dates like "October 14, 2025"
  const fullDateMatch = lower.match(
    /\b(january|february|march|april|may|june|july|august|september|october|november|december)\s+(\d{1,2}),\s+(\d{4})\b/
  );
  if (fullDateMatch) {
    const [, month, day, year] = fullDateMatch;
    return new Date(Number(year), monthMap[month], Number(day));
  }

  // Match month and year only like "October 2025"
  const monthYearMatch = lower.match(
    /\b(january|february|march|april|may|june|july|august|september|october|november|december)\s+(\d{4})\b/
  );
  if (monthYearMatch) {
    const [, month, year] = monthYearMatch;
    return new Date(Number(year), monthMap[month], 1);
  }

  return null;
};

export const closurePatterns = (() => {
  const start = new Date("2024-06-01");
  const end = new Date("2027-01-01");
  const list = [];

  // Month-based patterns (e.g., "july 2025")
  for (
    let date = new Date(start);
    date <= end;
    date.setMonth(date.getMonth() + 1)
  ) {
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    list.push({
      keyword: `${month.toLowerCase()} ${year}`,
      date: new Date(date),
    });
  }

  // Seasonal Dates
  const seasonal = [
    { keyword: "summer 2025", date: new Date("2025-06-15") },
    { keyword: "spring 2026", date: new Date("2026-03-15") },
    { keyword: "early 2026", date: new Date("2026-01-15") },
    { keyword: "late 2025", date: new Date("2025-11-01") },
    { keyword: "holiday 2025", date: new Date("2025-12-01") },
    { keyword: "fall 2025", date: new Date("2025-09-15") },
  ];

  // Specific Closure Dates
  const specific = [
    { keyword: "october 14, 2025", date: new Date("2025-10-14") },
    { keyword: "january 6, 2026", date: new Date("2026-01-06") },
    { keyword: "september 30, 2025", date: new Date("2025-09-30") },
  ];

  list.push(...seasonal, ...specific);

  return list;
})();